import { dataGridSortDirection } from '@shared/components';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringEnum,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

import { MONTH_ORDER } from '../../constants';
import { type MonthAbbreviation, ExamCourseType } from '../../types';

export function useExamCourseAnalysisReportSearchParams() {
  const [
    {
      startMonth,
      startYear,
      endMonth,
      endYear,
      examCenter,
      courseType,
      examCourse,
      qConfigRef,
      sortOrder,
    },
    setState,
  ] = useQueryStates({
    startMonth: parseAsStringLiteral<MonthAbbreviation>(MONTH_ORDER),
    startYear: parseAsInteger.withDefault(0),
    endMonth: parseAsStringLiteral<MonthAbbreviation>(MONTH_ORDER),
    endYear: parseAsInteger.withDefault(0),
    examCenter: parseAsArrayOf(parseAsString).withDefault([]),
    courseType: parseAsArrayOf(
      parseAsStringEnum<ExamCourseType>(Object.values(ExamCourseType)),
    ).withDefault([]),
    examCourse: parseAsArrayOf(parseAsString).withDefault([]),
    qConfigRef: parseAsArrayOf(parseAsString).withDefault([]),
    sortOrder: parseAsStringLiteral(dataGridSortDirection),
  });

  const changeFilterParams = (params: {
    startMonth: MonthAbbreviation | null;
    startYear: number | null;
    endMonth: MonthAbbreviation | null;
    endYear: number | null;
    examCenter: string[];
    courseType: ExamCourseType[];
    examCourse: string[];
    qConfigRef: string[];
  }) => {
    setState(params);
  };

  const changeSortOrder = (sortOrder: (typeof dataGridSortDirection)[number]) => {
    setState({ sortOrder });
  };

  return [
    {
      startMonth,
      startYear,
      endMonth,
      endYear,
      examCenter,
      courseType,
      examCourse,
      qConfigRef,
      sortOrder,
    },
    { changeFilterParams, changeSortOrder },
  ] as const;
}
